import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { useActionChoices } from "stores";
import { SmallText, Title } from "components";
import { FormNumberInput } from "form";
import { ACTION_STATUS } from "constants/actions";
import { ACTION_VIEW_MODE } from "constants/action-form";
import { OPERATIONS } from "constants/actions";
import DateSpan from "../date-span/DateSpan";
import { EquipmentUsed } from "../equipment";
import ActionModalDescriptionSection from "../description/ActionModalDescriptionSection";
import DetailSection from "../DetailSection";

const OtherActionPerformed = ({ viewMode, isFullWidth, isNewVersion }) => {
  const { t } = useTranslation();
  const status = ACTION_STATUS.performed;
  const isViewMode = viewMode === ACTION_VIEW_MODE.view;

  const { values } = useFormikContext();
  const { isSpecificOperation } = useActionChoices();

  const isHarvestOperation = useMemo(() => {
    return isSpecificOperation?.(
      OPERATIONS.OTHER.HARVEST,
      values?.otherAction?.operationTypeId,
    );
  }, [values?.otherAction?.operationTypeId, isSpecificOperation]);

  return (
    <div className="action-modal-card action-details-box ">
      <div className={isFullWidth && "details-half-width"}>
        <Title title={t("ActionModal.Details.Performed")} />
        {!isNewVersion && <DateSpan viewMode={viewMode} status={status} />}
        <EquipmentUsed isInEditMode={viewMode !== ACTION_VIEW_MODE.view} />
        {isHarvestOperation && (
          <DetailSection
            title={t("ActionModal.Output.Title")}
            isRequired={!isViewMode}
            isNewVersion={isNewVersion}
          >
            <FormNumberInput
              sx={{ width: "50%" }}
              name="otherAction.quantity"
              slotProps={{
                input: {
                  endAdornment: t(`OperationUnits.kilogram`),
                },
              }}
            />
            <SmallText className="field-description">
              {t("ActionModal.Output.Description")}
            </SmallText>
          </DetailSection>
        )}
        <ActionModalDescriptionSection task="other" isViewMode={isViewMode} isNewVersion={isNewVersion} />
      </div>
    </div>
  );
};

export default OtherActionPerformed;
